import { Component, Input, OnInit } from '@angular/core';
import { Projects } from "../../../../_shared/interfaces";
import {AlertService, IAlertType, ProjectsStoreService} from "../../../../_shared/services";
import {ClarityModule, ClrDatagridSortOrder} from "@clr/angular";
import {DatePipe, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-used-in-projects',
  standalone: true,
  imports: [
    NgIf,
    ClarityModule,
    RouterLink,
    DatePipe
  ],
  templateUrl: './used-in-projects.component.html',
  styleUrl: './used-in-projects.component.sass'
})
export class UsedInProjectsComponent implements OnInit {
  projects: Projects[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() componentId: string = '';

  constructor(
    private prss: ProjectsStoreService,
    private alertDispatcher: AlertService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.loadList(this.componentId);
  }

  loadList(component: string) {
    this.prss.getUsedProjectsPPS(component)
      .subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.show({
              message: ' Keine Projekte gefunden! ',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            this.loading = false;
            return;
          }
          this.projects = data.object;
        },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          return
        }
    })
  }

  formatProjectDate(value: string | null | undefined): string {
    const normalized = value?.trim() ?? '';
    if (!normalized || normalized === '0000-00-00') {
      return '';
    }
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(normalized)) {
      return normalized;
    }
    return this.datePipe.transform(normalized, 'dd.MM.yyyy') ?? normalized;
  }
}
